const routesAutomations = [
  {
    path: '/automations/:propertyId/energy/:solarbotId',
    name: 'AutomationsEnergyUnit',
    component: () => import('@/views/automations/EnergyUnitView.vue'),
    meta: {
      title: 'Energy',
      backgroundTheme: 'brand-reset'
    }
  },
  {
    path: '/automations/:propertyId/solar',
    name: 'AutomationsSolar',
    component: () => import('@/views/automations/solar-mode/SolarModeView.vue'),
    meta: {
      title: 'Solar optimisations',
      backgroundTheme: 'brand-reset'
    }
  },
  {
    path: '/automations/:propertyId/solar-mode/:unitId',
    name: 'AutomationsSolarModeSummary',
    component: () =>
      import('@/views/automations/solar-mode/SolarModeSummaryView.vue'),
    meta: {
      title: 'Solar mode',
      backgroundTheme: 'brand-reset'
    }
  },
  {
    path: '/automations/:propertyId/away-mode',
    name: 'AutomationsAwayModeProperty',
    component: () => import('@/views/automations/AwayModePropertyView.vue'),
    meta: {
      title: 'Away mode',
      backgroundTheme: 'brand-reset'
    }
  },
  {
    path: '/automations/:propertyId/water',
    name: 'AutomationsHotWaterProperty',
    component: () => import('@/views/automations/HotWaterPropertyView.vue'),
    meta: {
      title: 'Hot water optimisations',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/automations/:propertyId/water/routines',
    name: 'AutomationsMultipleHotWaterRoutines',
    component: () =>
      import('@/views/automations/HotWaterMultipleRoutinesView.vue'),
    meta: {
      title: 'Hot water routines',
      backgroundTheme: 'brand-light'
    }
  },
  {
    path: '/automations/:propertyId/water/routines/:unitId',
    name: 'AutomationsHotWaterRoutines',
    component: () => import('@/views/automations/HotWaterRoutinesView.vue'),
    meta: {
      title: 'Hot water routines',
      backgroundTheme: 'brand-reset'
    }
  },
  {
    path: '/automations/:propertyId/water/routines/:unitId/create',
    name: 'AutomationsHotWaterCreateRoutine',
    component: () =>
      import('@/views/automations/HotWaterCreateRoutineView.vue'),
    meta: {
      title: 'Create a new routine',
      backgroundTheme: 'brand-reset'
    }
  },
  {
    path: '/automations/:propertyId/water/routines/:unitId/edit',
    name: 'AutomationsHotWaterEditRoutine',
    component: () =>
      import('@/views/automations/HotWaterCreateRoutineView.vue'),
    meta: {
      title: 'Edit routine',
      backgroundTheme: 'brand-reset'
    }
  }
]

export default routesAutomations
